// extracted by mini-css-extract-plugin
module.exports = {"container":"RKQj2KdgIhciu6V3V8iy2","icon":"TTXusijfk7N4LXZxlGSrU"};